import { isUp2boatId } from '@modules/bcm/@shared/services/up2boat-id-selection.service';

/** Minimum length for text search in booking-v2 pickers (not applied to a full Up2Boat-ID). */
export const BOOKING_V2_MIN_SEARCH_LENGTH = 2;

export function isBookingV2SearchTooShort(raw: string): boolean {
    const q = String(raw ?? '').trim();
    if (!q) {
        return true;
    }
    if (isUp2boatId(q)) {
        return false;
    }
    return q.length < BOOKING_V2_MIN_SEARCH_LENGTH;
}
